import ApolloClient from 'apollo-boost'
import fetch from 'isomorphic-fetch'

export const Client = new ApolloClient({
	uri:
		`https://graphql.contentful.com/content/v1/spaces/${process.env.GATSBY_CONTENTFUL_SPACE_ID}/environments/master?access_token=${process.env.GATSBY_CONTENTFUL_DELIVERY_TOKEN}`,
	fetch,
})
